import React from 'react'
import type { RouteDef } from '@ztechapps/common.contract'
import { useHistory } from '@ztechapps/common.hook'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { BusyButton } from '@ztechapps/webui.button'
import { RichTextDisplay } from '@ztechapps/webui.input'
import { Modal, ModalDragHandle } from '@ztechapps/webui.modal'
import { useWhatsNewContext } from './Context'

export const WhatsNewModal = () => {
  const { post, open, closeWhatsNew } = useWhatsNewContext()
  const history = useHistory()
  const blogPreviewRoute = useInject<RouteDef>(WebuiIocKey.routes.blogPreview)

  if (!post) return null

  const onOpenFullPost = () => history.push(blogPreviewRoute.altPath({ slug: post.slug ?? '' }))

  return (
    <Modal show={open} onHide={closeWhatsNew} size="lg" scrollable trigger={() => null}>
      <ModalDragHandle>
        <span className="fs-5 fw-semibold">What&apos;s New</span>
      </ModalDragHandle>
      <Modal.Body>
        <h4>{post.title}</h4>
        {/* trustedSource: release notes are authored by staff in this same admin app, not attacker-reachable */}
        <RichTextDisplay contentHtml={post.contentHtml ?? ''} trustedSource />
      </Modal.Body>
      <Modal.Footer>
        <BusyButton variant="outline-secondary" icon="external-link" text="Open full post" onClick={onOpenFullPost} />
        <BusyButton text="Close" onClick={closeWhatsNew} />
      </Modal.Footer>
    </Modal>
  )
}
